<template>
  <div>
    <b-modal
      id="modal-unresolved"
      ref="modal-unresolved"
      centered
      title="Unchecked"
      size="lg"
      modal-class="mc-control-tower__resolve"
      @show="handleModalShow"
      @hide="handleUnselectAll"
    >
      <div class="__table-top">
        <span>
          {{ `${momentDateShortMonth(period[0])} - ${momentDateShortMonth(period[1])}` }}
        </span>
        <b-input-group size="sm" class="mc-has-search mc-input" @click="focusSearch">
          <template #prepend>
            <i class="mc-icon icon-fill_search"></i>
          </template>
          <b-form-input
            ref="searchInput"
            :value="search"
            :disabled="isBusy"
            :placeholder="$t('global.search') + '...'"
            @input="handleSearchChange"
          />
          <template v-if="search" #append>
            <button class="clear-search-btn" :disabled="isBusy" @click="handleClearSearch">
              <i class="pe-2 mc-icon icon-outline_close"></i>
            </button>
          </template>
        </b-input-group>
      </div>
      <div class="__table-top">
        <div>
          <h6 v-if="selectAll || selectedValuesLength" class="mc-row-check mt-0">
            <span class="badge btn-success">{{ selectedValuesLength }}</span>
            {{ $t('global.object.selectedRow') }}
            <a class="color-primary" @click="handleUnselectAll">
              {{ $t('global.action.deselect') }}
            </a>
          </h6>
          <div v-else class="my-3"></div>
        </div>
        <McButton
          v-if="selectedValuesLength || selectAll"
          v-b-modal.modal-confirm-resolve
          variant="secondary"
          :text="$t('controlTower.resolve.markChecked')"
        />
      </div>
      <div class="__table-container">
        <b-table
          ref="table-ref"
          :fields="fields"
          :items="items"
          :busy="isBusy"
          class="-w-auto text-nowrap sticky-head-table border"
          show-empty
          selectable
          select-mode="multi"
          @row-clicked="handleRowClicked"
        >
          <template #empty>
            <div v-show="!isBusy" class="text-center my-4">
              {{ $t('global.emptyTable') }}
            </div>
          </template>
          <template #head(checkbox)>
            <div class="form-check">
              <input
                v-model="selectAll"
                class="form-check-input me-1"
                type="checkbox"
                value="all"
                @input="toggleAll"
              />
            </div>
          </template>
          <template #cell(checkbox)="{ index, item }">
            <div class="form-check">
              <b-form-checkbox
                v-model="selectedValues[item.rawAlertId]"
                @change="handleCheckboxChange($event, item, index)"
              />
            </div>
          </template>
          <template #cell(alert)="data">
            <span v-if="hasRuleNameScope">
              {{
                hasRuleNameScope && data.item.alertRule?.label
                  ? data.item.alertRule.label
                  : $i18n.locale === 'id'
                  ? data.value.descriptionIdn
                  : data.value.descriptionEng
              }}
              <p v-if="data.item.alertRule" class="text-muted">
                {{ $i18n.locale === 'id' ? data.value.descriptionIdn : data.value.descriptionEng }}
              </p>
            </span>
            <span v-else>
              {{ $i18n.locale === 'id' ? data.value.descriptionIdn : data.value.descriptionEng }}
            </span>
          </template>
          <template #cell(vehicle)="data">
            <span>{{ data.value.licensePlate }}</span>
          </template>
          <template #cell(createdOn)="data">
            <div class="d-flex flex-column">
              <span>{{ momentDateShortMonth(data.item.createdOn) }}</span>
              <span class="text-muted">
                {{ momentTimeSeconds(data.item.createdOn) }} {{ getLabelTimezone() }}
              </span>
            </div>
          </template>
          <template #cell(action)="data">
            <McButton
              :text="$t('global.action.seeDetail')"
              size="sm"
              @click="openDetailNotification(data.item)"
            />
          </template>
        </b-table>
        <div v-observe-visibility="handleElementObserved" style="height: 1px"></div>
        <div v-if="hasNextPage">
          <div v-if="isBusy" class="px-2 py-2 d-flex gap-2">
            <b-skeleton width="2.5%" />
            <b-skeleton width="97.5%" />
          </div>
          <div v-else class="text-center my-2"></div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.close')"
          @click="cancel()"
        />
      </template>
    </b-modal>
    <b-modal
      id="modal-confirm-resolve"
      :title="$t('controlTower.resolve.resolveAllNotification')"
      centered
      size="md"
    >
      <div>
        <p>{{ $t('controlTower.resolve.markAsResolve') }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          :disabled="isBusy"
          @click="cancel()"
        />

        <McButton
          :text="
            isBusy
              ? 'Sedang Diproses'
              : `${$t('global.action.yes')}, ${$t('controlTower.checkAll')}`
          "
          :class="isBusy ? 'btn-secondary' : 'btn-primary'"
          :disabled="isBusy"
          :icon="isBusy ? 'spinner-border spinner-border-sm' : ''"
          @click="handleResolve()"
        />
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  GET_RAW_ALERTS_WITH_ADDRESS,
  UPSERT_RAW_ALERTS_ACTION,
} from '@/services/api/driverscore/score'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { debounce } from '@/helpers/debounce'
import McButton from '@/components/McButton'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },
  mixins: [Helper, MixPanel],
  props: {
    period: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ids: [],
      items: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      search: '',
      isPagination: true,
      isBusy: false,
      selectAll: false,
      selectedValues: {},
      selectedObject: {},
      exclude: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          key: 'checkbox',
          label: '',
        },
        {
          key: 'alert',
          label: this.$t('report.fields.alertType'),
        },
        {
          key: 'vehicle',
          label: this.$t('global.object.licensePlate'),
        },
        {
          key: 'createdOn',
          label: this.$t('global.eventTime'),
        },
        {
          key: 'action',
          label: this.$t('global.field.action'),
        },
      ]
    },
    hasNextPage() {
      if (!this.isPagination) return false

      if (!this.totalCount || this.totalCount === 0) return false
      return this.page * this.limit < this.totalCount
    },
    selectedValuesLength() {
      if (this.selectAll) return this.totalCount - this.exclude.length
      else
        return Object.keys(this.selectedValues).filter((value) => this.selectedValues[value]).length
    },
    hasRuleNameScope() {
      return this.hasAccess('e4J-alert-rule-name-as-title:read')
    },
  },

  watch: {
    exclude: {
      handler(newValue) {
        newValue.forEach((item) => {
          this.$delete(this.selectedObject, item.rawAlertId)
        })
      },
    },
  },
  methods: {
    handleModalShow() {
      this.$nextTick(() => {
        this.page = 1
        this.getData(
          {
            pagination: {
              page: this.page,
              show: this.limit,
            },
          },
          true
        )
      })
    },
    async getData(opts, reset = false) {
      this.isBusy = true
      const res = await this.$apollo.query({
        query: GET_RAW_ALERTS_WITH_ADDRESS,
        variables: {
          filter: {
            isUrgent: this.hasAccess(['e4e-alert-center-urgent:read']) ? true : undefined,
            isImportant: true,
            isResolved: false,
            orderBy: JSON.stringify({ createdOn: 'desc' }),
            startDate: moment(this.period[0]).set('second', 0).toISOString(),
            endDate: moment(this.period[1]).set('second', 59).toISOString(),
            ...opts,
          },
        },
        fetchPolicy: 'no-cache',
      })

      if (!res || res.errors) return
      this.items = reset
        ? res.data.rawAlerts.rawAlerts.data
        : [...this.items, ...res.data.rawAlerts.rawAlerts.data]
      if (this.selectAll) {
        const newRows = res.data.rawAlerts.rawAlerts.data.filter(
          (item) => !this.exclude.includes(item.rawAlertId)
        )

        this.$nextTick(() => {
          newRows.forEach((row) => {
            const idx = this.items.findIndex((i) => i.rawAlertId === row.rawAlertId)
            if (idx !== -1) {
              this.$set(this.selectedValues, row.rawAlertId, true)
              this.$set(this.selectedObject, row.rawAlertId, row)
              this.$refs['table-ref'].selectRow(idx)
            }
          })
        })
      }
      this.ids = this.items.map((item) => item.rawAlertId)
      this.totalCount = res.data.rawAlerts.rawAlerts.pagination.total
      this.page = res.data.rawAlerts.rawAlerts.pagination.page
      this.isBusy = false
    },
    focusSearch() {
      this.$refs['searchInput'].focus()
    },
    handleSearchChange: debounce(async function (_search) {
      this.search = _search
      const opts = {
        search: _search != '' ? _search : undefined,
        pagination: {
          page: 1,
          show: this.limit,
        },
      }
      await this.getData(opts, true)
      this.focusSearch()
    }, 500),
    handleClearSearch() {
      this.handleSearchChange(undefined)
      this.search = ''
    },
    handleElementObserved(isVisible) {
      if (!isVisible) return
      if (!this.hasNextPage) return
      if (this.items.length == 0 && this.search) return
      this.getData({
        pagination: {
          page: this.page + 1,
          show: this.limit,
        },
        search: this.search != '' ? this.search : undefined,
      })
    },
    async handleResolve() {
      this.isBusy = true

      const selectedIds = Object.keys(this.selectedValues)
        .filter((key) => this.selectedValues[key] === true)
        .map((key) => parseInt(key))

      let input = {}
      if (this.selectAll) {
        const rawAlertId = this.exclude.length ? { rawAlertId: this.exclude } : {}

        input = {
          selectionMode: this.exclude.length ? 'Exclude' : 'All',
          actionType: 'Resolve',
          data: 'true',
          dateRange: {
            start: moment(this.period[0]).set('second', 0).toISOString(),
            end: moment(this.period[1]).set('second', 59).toISOString(),
          },
          ...rawAlertId,
          search: this.search != '' ? this.search : undefined,
        }
      } else {
        input = {
          selectionMode: 'Selection',
          actionType: 'Resolve',
          data: 'true',
          rawAlertId: selectedIds,
          dateRange: {
            start: moment(this.period[0]).set('second', 0).toISOString(),
            end: moment(this.period[1]).set('second', 59).toISOString(),
          },
        }
      }

      try {
        const res = await this.$apollo.mutate({
          mutation: UPSERT_RAW_ALERTS_ACTION,
          variables: { input },
        })
        const update = res.data.upsertRawAlertsAction.upsertRawAlertsAction
        if (!res.data.upsertRawAlertsAction.isSuccessful) {
          this.$mcToast.error(res.data.upsertRawAlertsAction.message)
          this.$bvModal.hide('modal-confirm-resolve')
          return
        } else {
          this.$mcToast.success(
            `${update.aggregate.updatedAlerts} ${this.$t('controlTower.resolve.successResolve')}`
          )
          this.$emit('resolved', update.aggregate.updatedAlerts)
          this.track('Resolve-All Notification from Control Tower V2')
        }
      } catch (err) {
        this.$mcToast.error(this.$t('global.error'))
      } finally {
        this.$bvModal.hide('modal-confirm-resolve')
        this.$bvModal.hide('modal-unresolved')
        this.isBusy = false
      }
    },
    openDetailNotification(item) {
      const createdOn = new Date(item.createdOn).getTime()
      const id = item.rawAlertId
        ? item.rawAlertId
        : `${item.alertCode}-${item.vehicleId}-${createdOn}-${item.alertFlag}`
      const routePath = this.$router.resolve({
        name: 'Notification Detail',
        params: {
          id: id,
        },
      })

      window.open(routePath.href, '_blank')
    },
    toggleAll($event) {
      let checked = $event.target.checked
      if (checked) {
        this.handleSelectAll()
      } else {
        this.handleUnselectAll()
      }
    },
    assignSelectedObject(checked, item) {
      if (checked) {
        if (this.selectAll && !this.exclude.includes(item.rawAlertId)) {
          this.exclude.push(item.rawAlertId)
        }
        if (this.exclude.length == 0) this.selectAll = false
        this.$delete(this.selectedObject, item.rawAlertId)
        return
      }

      if (this.exclude.length && this.exclude.includes(item.rawAlertId)) {
        if (this.selectAll) {
          this.exclude = this.exclude.filter((id) => id !== item.rawAlertId)
        }
      } else {
        this.exclude = []
      }
      this.$set(this.selectedObject, item.rawAlertId, item)
    },
    handleRowClicked(item, index) {
      const checked = this.selectedValues[item.rawAlertId]
      const newChecked = !checked

      this.$set(this.selectedValues, item.rawAlertId, newChecked)

      this.assignSelectedObject(!newChecked, item)

      if (!newChecked) {
        this.$refs['table-ref'].selectRow(index)
      } else {
        this.$refs['table-ref'].unselectRow(index)
      }

      this.$emit('row-selected', this.selectedValuesLength)
    },
    handleCheckboxChange(targetChecked, item, index) {
      this.assignSelectedObject(!targetChecked, item)

      if (targetChecked) {
        this.$refs['table-ref'].selectRow(index)
      } else {
        this.$refs['table-ref'].unselectRow(index)
      }
    },
    handleSelectAll() {
      this.ids.forEach((item) => {
        this.$set(this.selectedValues, item, true)
        this.$set(this.selectedObject, item, { rawAlertId: item })
      })
      this.$refs['table-ref'].selectAllRows()
      this.selectAll = true
    },
    handleUnselectAll() {
      this.selectAll = false
      this.selectedValues = {}
      this.selectedObject = {}
      this.$refs['table-ref'].clearSelected()
    },

    handleManualLoadMore() {
      this.getData({
        pagination: {
          page: this.page + 1,
          show: this.limit,
        },
        search: this.search != '' ? this.search : undefined,
      })
    },
  },
}
</script>
<style lang="scss">
@import '../style.scss';
</style>
